import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { QIcon_check_mark, QIcon_download } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useEventTracking } from '../../../helpers/gtmHelper'
import apis from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_common, n_credit, n_pricing, n_purchase } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { isFirstBenefitUser } from '../../../modules/utils'
import { COUNTRY_ALPHA2_CODE } from '../../../modules/vars'
import { FIRST_CREDIT_COUNT, LAST_CREDIT_COUNT, SECOND_CREDIT_COUNT, THIRD_CREDIT_COUNT } from './ProductCard'

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
export interface ISelectedItem {
  id: number
  coupon_count: number
  total_coupon_count: number
  name: string
  duration: number
  exp_dates: number
  exp_weeks: number
  prices: Prices
  discounts: Discount[]
  available_discount_coupon: {
    amount: {
      value: number
      formatted: string
    }
    title: string
  }
  total_discount_amount: AvailablePoint
  discount_rate: number
  available_point: AvailablePoint
  expected_point: AvailablePoint
  first_purchase_benefit_count: number
  is_weekly_lesson_package: boolean
  include_booking_priority_benefit: boolean
  name_for_admin: string
  potential_discount_coupon_amount: {
    value: number
    formatted: string
  }
}

export interface AdditionalCouponCount {
  type: string
  count: number
}

export interface AvailablePoint {
  value: number
  formatted: string
}

export interface Discount {
  title: string
  amount: AvailablePoint
}

export interface Prices {
  list_price: AvailablePoint
  sale_price: AvailablePoint
  price_per_month: AvailablePoint
  price_per_lesson: AvailablePoint
}
export interface IProductGroups {
  product_line: ProductLine
}

export interface ProductLine {
  id: number
  coupon_count: number
  total_coupon_count: number
  name: string
  duration: number
  exp_dates: number
  exp_weeks: number
  prices: Prices
  discounts: Discount[]
  available_discount_coupon: null
  total_discount_amount: AvailablePoint
  discount_rate: number
  available_point: AvailablePoint
  expected_point: AvailablePoint
  first_purchase_benefit_count: number
  is_weekly_lesson_package: boolean
  include_booking_priority_benefit: boolean
  name_for_admin: string
}

export interface AvailablePoint {
  value: number
  formatted: string
}

export interface Discount {
  title: string
  amount: AvailablePoint
}

export interface Prices {
  list_price: AvailablePoint
  sale_price: AvailablePoint
  price_per_month: AvailablePoint
  price_per_lesson: AvailablePoint
}

interface IUpSellingPopupBody {
  countryCode: any
  selectedItem: ISelectedItem
  productsGroup: IProductGroups[]
  refetch?: () => void
}
//------------------------------------------------------------------------------
//------------------------------------------------------------------------------

const getTargetedItem = (selectedItem, productsGroup) => {
  switch (selectedItem?.coupon_count) {
    case FIRST_CREDIT_COUNT:
      return productsGroup.filter((product) => product.coupon_count == SECOND_CREDIT_COUNT)[0]
    case SECOND_CREDIT_COUNT:
      return productsGroup.filter((product) => product.coupon_count == THIRD_CREDIT_COUNT)[0]
    case THIRD_CREDIT_COUNT:
      return productsGroup.filter((product) => product.coupon_count == LAST_CREDIT_COUNT)[0]
    default:
      return []
  }
}
const UpSellingPopupBody = ({ countryCode, selectedItem, productsGroup, refetch }: IUpSellingPopupBody) => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const router = useAppRouter()
  const { sendClickEvent, sendPageViewEvent } = useEventTracking()
  const [isDownloadCoupon, setIsDownloadCoupon] = useState<boolean>(false)

  const isApp = router.query.app ? true : false
  const convertedCountryCode = countryCode == COUNTRY_ALPHA2_CODE.KR ? countryCode : COUNTRY_ALPHA2_CODE.US

  const targetedItem: ISelectedItem = getTargetedItem(selectedItem, productsGroup)
  const isKoreanWon = countryCode == COUNTRY_ALPHA2_CODE.KR

  console.log(selectedItem, 'selectedItem')
  console.log(targetedItem, 'targetedItem')
  console.log(selectedItem?.prices?.sale_price.value, ' selectedItem?.prices?.sale_price.value ')
  console.log(
    targetedItem?.prices?.price_per_lesson.value * selectedItem?.total_coupon_count,
    'targetedItem?.prices?.price_per_lesson.value * selectedItem?.total_coupon_count'
  )

  // 사용가능한 쿠폰이 있는지 여부
  const isAvailableCouponExist =
    (targetedItem?.potential_discount_coupon_amount != null &&
      targetedItem?.potential_discount_coupon_amount?.value > 0) ||
    false

  const lastPricing = targetedItem?.prices.sale_price.value - targetedItem?.available_point.value

  const upsellingDiscountAmount =
    selectedItem?.prices?.sale_price.value -
    (lastPricing / targetedItem.coupon_count) * selectedItem?.total_coupon_count

  const lastPricingFormatted =
    (!isKoreanWon ? '$' : '') + (isKoreanWon ? lastPricing.toLocaleString('ko-KR') + '원' : lastPricing)

  const upsellingDiscountAmountPlusPointDiscount = upsellingDiscountAmount

  const upsellingDiscountAmountPlusPointDiscountFormatted =
    (!isKoreanWon ? '$' : '') +
    (isKoreanWon
      ? upsellingDiscountAmountPlusPointDiscount.toLocaleString('ko-KR') + '원'
      : upsellingDiscountAmountPlusPointDiscount)

  // 쿠폰 받기 클릭시 POST
  const handleClickDownloadCoupon = async (id) => {
    if (isDownloadCoupon) return
    sendClickEvent({
      button_name: 'upselling_click_coupon_download',
      object_title: t(n_purchase.upsell_coupon.secret_coupon(targetedItem?.coupon_count)),
      location_detail: `${targetedItem?.potential_discount_coupon_amount?.formatted}`,
    })
    const response = await axiosPost(apis.products.productLineDiscountCoupon({ productLineId: id }), {})

    if (response?.discount_coupon) {
      refetch()
      setIsDownloadCoupon(true)
    } else {
      refetch()
      alert(response?.error)
    }
  }

  // 구매 버튼 클릭
  const clickOriginPuchaseButton = () => {
    sendClickEvent({
      button_name: 'upselling_click_original_purchase',
      object_title: t(n_credit.count(selectedItem?.coupon_count)),
      location_detail: selectedItem?.prices.sale_price.formatted,
    })

    router.push(
      `${urls.student.newPortal.pricing.detail(selectedItem?.id)}?country_code=${convertedCountryCode}&app=${isApp}`
    )
  }

  // 바꿔 구매 버튼 클릭
  const clickExchangePuchaseButton = async (id) => {
    if (isAvailableCouponExist) {
      await axiosPost(apis.products.productLineDiscountCoupon({ productLineId: id }), {})
    }

    sendClickEvent({
      button_name: 'upselling_click_exchange_purchase',
      object_title: t(n_credit.count(targetedItem?.coupon_count)),
      location_detail: targetedItem?.prices.sale_price.formatted,
    })

    router.push(
      `${urls.student.newPortal.pricing.detail(targetedItem?.id)}?country_code=${convertedCountryCode}&app=${isApp}`
    )
  }

  useEffect(() => {
    sendPageViewEvent({ page_name: 'upselling_modal_page_view' })
  }, [])

  // 이미 쿠폰을 받았는지 여부를 판단
  useEffect(() => {
    if (
      targetedItem &&
      targetedItem?.available_discount_coupon != null &&
      targetedItem?.available_discount_coupon?.amount?.value > 0
    ) {
      setIsDownloadCoupon(true)
    } else {
      setIsDownloadCoupon(false)
    }
  }, [targetedItem])

  return (
    <div className="px-[20px] pt-[32px] sm:px-[0px] text-black">
      {!isAvailableCouponExist && <div className="Headline3-22Bd mb-[24px]">{t(n_pricing.upsell.five_hundred)}</div>}
      {isAvailableCouponExist && (
        <div>
          <div className="flex justify-center">
            <img
              src={'https://d38emex6h5e12i.cloudfront.net/2024-image/1715935245586_coupon_image_1.png'}
              alt="coupon"
              className="w-[72px] h-[72px]"
            />
          </div>
          <div className="text-center Headline3-22Bd my-[32px]">{t(n_pricing.upsell.five_hundred)}</div>
          <div className="mb-[32px] border-1 px-[16px] py-[12px] bg-gray-50 flex flex-row justify-between rounded-[8px] w-full items-center">
            <div className="flex flex-row items-center gap-[16px]">
              <div className="min-w-[24px]">
                <img
                  src={'https://d38emex6h5e12i.cloudfront.net/2024-image/1715935967915_coupon.webp'}
                  alt="coupon"
                  className="w-[24px] h-[24px]"
                />
              </div>
              <div className="flex flex-col">
                <div className="Body2-14Md text-gray-600 mb-[2px]">
                  {t(n_purchase.upsell_coupon.secret_coupon(targetedItem?.coupon_count))}
                </div>
                <div className="Body2-14Bd">{targetedItem?.potential_discount_coupon_amount?.formatted}</div>
              </div>
            </div>
            <div className="">
              <DSButton
                size={BUTTON_SIZE.XS}
                type={BUTTON_TYPE.OUTLINE}
                disabled={isDownloadCoupon}
                onClick={() => handleClickDownloadCoupon(targetedItem?.id)}
              >
                <DSButton.Label className={classNames({ '!text-gray-400': isDownloadCoupon })}>
                  {t(isDownloadCoupon ? n_purchase.upsell_coupon.download_done : n_purchase.upsell_coupon.download)}
                </DSButton.Label>
                <DSButton.Icon alt="download">
                  {isDownloadCoupon ? (
                    <QIcon_check_mark color={COLORS.GRAY500} width={12} height={12} className="ml-[2px]" />
                  ) : (
                    <QIcon_download color={COLORS.GRAY500} width={12} height={12} className="ml-[2px]" />
                  )}
                </DSButton.Icon>
              </DSButton>
            </div>
          </div>
        </div>
      )}

      <div className="flex sm:hidden Title2-18Bd pt-[4px] mb-[24px]">{t(n_pricing.upsell.title)}</div>
      <div className="Caption-12Md text-gray-500 flex flex-row gap-[4px]">
        <div className="">{selectedItem?.duration === 40 ? t(n_common.label_40min) : t(n_common.label_20min)}</div>{' '}
        <div className="">
          {selectedItem?.is_weekly_lesson_package ? t(n_pricing.every_week.content_title) : t(n_pricing.none.title)}
        </div>
      </div>
      <div className="flex flex-col gap-[8px] mt-[8px]">
        <div className="border-1 flex flex-col items-start sm:flex-row justify-between sm:items-center sm:py-[20px] sm:pl-[20px] p-[16px] sm:pr-[24px] rounded-[8px]">
          <div className="flex flex-col">
            <div className="Body1-16Md">
              <div className="relative flex flex-row">
                {t(n_pricing.package.name(selectedItem?.coupon_count))}
                {isFirstBenefitUser(currentUser) && selectedItem?.first_purchase_benefit_count > 0 && (
                  <div className="ml-[4px]">+ {t(n_credit.count(selectedItem?.first_purchase_benefit_count))}</div>
                )}
              </div>
            </div>
            <div className="flex flex-row items-center gap-[8px] mt-[4px]">
              <div className="Body1-16Bd">{selectedItem?.prices.sale_price.formatted}</div>
            </div>
          </div>
          <div className="smd:flex smd:w-full smd:justify-end">
            <div className="w-[100px]">
              <DSButton type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.MD} onClick={() => clickOriginPuchaseButton()}>
                <DSButton.Label className="whitespace-nowrap">{t(n_pricing.upsell.purchase)}</DSButton.Label>
              </DSButton>
            </div>
          </div>
        </div>
        <div className="border-1 flex flex-col sm:flex-row justify-between items-start sm:items-center sm:py-[20px] sm:pl-[20px] p-[16px] sm:pr-[24px] rounded-[8px]">
          <div className="flex flex-col">
            <div className="Body1-16Md">
              <div className="relative flex flex-row">
                {t(n_pricing.package.name(targetedItem?.coupon_count))}
                {isFirstBenefitUser(currentUser) && targetedItem?.first_purchase_benefit_count > 0 && (
                  <div className="ml-[4px]">+ {t(n_credit.count(selectedItem?.first_purchase_benefit_count))}</div>
                )}
              </div>
            </div>
            <div className="flex flex-row items-center gap-[8px] mt-[4px]">
              {/* 이전 가격 */}
              <div className="Body1-16Bd line-through text-gray-400">{targetedItem?.prices.sale_price.formatted}</div>
              {/* 최종 가격 */}
              <div className="Body1-16Bd">{lastPricingFormatted}</div>
            </div>
            <div className="Body2-14Md text-red-600 mt-[4px]">
              <div className="">
                {t(n_pricing.upsell.benefit_save(upsellingDiscountAmountPlusPointDiscountFormatted))}
              </div>
              {isAvailableCouponExist && (
                <div className="">
                  {t(
                    n_purchase.upsell_coupon.secret_coupon_benefit(
                      targetedItem?.potential_discount_coupon_amount?.formatted
                    )
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="smd:flex smd:w-full smd:justify-end smd:mt-[8px]">
            <div className="w-[100px]">
              <DSButton
                type={BUTTON_TYPE.SOLID}
                size={BUTTON_SIZE.MD}
                onClick={() => {
                  clickExchangePuchaseButton(targetedItem?.id)
                }}
              >
                <DSButton.Label className="whitespace-nowrap">{t(n_pricing.upsell.change_to_purchase)}</DSButton.Label>
              </DSButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpSellingPopupBody
